<script setup lang="ts">
import {TeamRole} from "@/types";
import {computed, ref} from "vue";

interface Props {
    value: TeamRole
    hideOwner?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    hideOwner: true
})

const model = ref<Array<TeamRole>>([props.value])

const emit = defineEmits<{
    (e: 'update:modelValue', value: TeamRole): void
}>()

const options: Array<{ label: string; value: TeamRole }> = [
    {label: 'Owner', value: 'owner'},
    {label: 'Admin', value: 'admin'},
    {label: 'User', value: 'user'},
    {label: 'Guest', value: 'guest'}
]

const filteredOptions = computed(() => {
    if (props.hideOwner) {
        return options.filter(option => option.value !== 'owner')
    }
    return options
})
</script>

<template>
    <v-menu
        location="top"
    >
        <template #activator="{ props: bind }">
            <v-btn
                v-bind="bind"
                variant="text"
                border="sm"
                color="base"
                size="small"
                class="text-body-2 text-none text-capitalize"
                height="32"
            >
                <span class="font-weight-regular">
                    {{ props.value }}
                </span>
                <v-icon class="ml-1">
                    mdi-chevron-down
                </v-icon>
            </v-btn>
        </template>
        <v-list
            v-model:selected="model"
            rounded="lg"
            border="sm"
            elevation="0"
            class="bg-background pa-0"
            width="250"
            @update:selected="emit('update:modelValue', model[0])"
        >
            <v-list-subheader class="custom-subheader">
                Change role
            </v-list-subheader>
            <v-divider />
            <v-list-item
                v-for="option in filteredOptions"
                :key="option.value"
                :value="option.value"
                class="text-body-2 pl-5 ma-1"
                density="compact"
                rounded
            >
                {{ option.label }}
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<style scoped>
.custom-subheader {
    font-size: 0.750rem;
    font-weight: 500;
    color: #2D2D30;
}
</style>
